import { faChevronLeft, faChevronRight } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Calendar from 'react-calendar';
import { Value } from 'react-calendar/dist/cjs/shared/types';

import './style.scss';

interface CalendarProps {
  value: string | [string, string];
  handler?: React.Dispatch<Date>;
  handlerRange?: React.Dispatch<[string, string]>;
  selectRange?: boolean | false;
  maxDate?: Date | undefined;
  minDate?: Date | undefined;
  newVersion?: boolean;
  locale?: string;
}

export default function CustomCalendar(props: CalendarProps) {
  const {
    value,
    handler,
    handlerRange,
    selectRange,
    maxDate,
    minDate,
    newVersion,
    locale = 'en-US',
  } = props;

  const handleChangeArray = (event: any) => {
    if (event) {
      const arr: [string, string] = [event[0].toString(), event[1]!.toString()];

      if (handlerRange) {
        handlerRange(arr);
      }
    }
  };

  const handleChange = (event: Value) => {
    if (handler) {
      handler(event as Date);
      return;
    }
  };

  return (
    <Calendar
      onChange={(evt) => (selectRange ? handleChangeArray(evt) : handleChange(evt))}
      value={value}
      next2Label={null}
      prev2Label={null}
      maxDate={maxDate || new Date()}
      minDate={minDate || new Date('2019-03-20')}
      nextLabel={<FontAwesomeIcon icon={faChevronRight} />}
      prevLabel={<FontAwesomeIcon icon={faChevronLeft} />}
      selectRange={selectRange}
      className={`${selectRange ? 'calendar-with-range' : ''} ${newVersion ? 'calendar-v2' : ''}`.trim()}
      locale={locale}
    />
  );
}
